export default __webpack_public_path__ + "static/media/gril-with-barbell.7441e587.png";